<template>
    <div>
        <div class="form-row">

            <div class="col col-12 col-md-6">

                <az-input
                    :label="can_remove ? ( value.fl_indicador ? 'Indicador' : '' ) : 'Nome do Solicitante'"
                    sizing="sm"
                    :edicao="edicao"
                    :required="required"
                    :validate="validate"
                    v-model="value.medico_solicitante.st_nome"
                    v-if="value.medico_solicitante && value.medico_solicitante.edicao && false">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend">
                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="value.excluido = true" v-if="can_remove">
                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="value.medico_solicitante && value.medico_solicitante.id_medico_solicitante">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                v-if="false"
                                @click="value.medico_solicitante.edicao = !value.medico_solicitante.edicao"
                                :disabled="$store.state.loading">
                                <i :class="value.medico_solicitante.edicao ? 'fa fa-search' : 'fas fa-pen'"></i>
                            </button>
                        </div>
                        <div class="input-group-append" v-if="value.medico_solicitante && !value.medico_solicitante.id_medico_solicitante">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                @click="value.medico_solicitante.edicao = false" :disabled="$store.state.loading">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>

                    </template>
                </az-input>

                <az-input
                    v-else
                    :label="can_remove ? ( value.fl_indicador ? 'Indicador' : '' ) : 'Nome do Solicitante'"
                    sizing="sm"
                    type="autocomplete"
                    optionsMode="aql"
                    service="medico_solicitantes.index"
                    optionsDisplay="search"
                    :optionsSync="true"
                    :optionsExternal="block_incluir ? false : true"
                    :edicao="edicao"
                    :required="required"
                    :validate="validate"
                    v-model="value.medico_solicitante"
                    @input="tratarMedico"
                    @onSearch="setNomeMedico">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend" v-if="can_remove">
                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="value.excluido = true">
                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb>
                        <div class="input-group-append"
                            v-if="( !value.medico_solicitante || !value.medico_solicitante.st_nome ) &&
                            ( !value.medico || !value.medico.fl_agenda_compartilhada ) && ( !block_executante )">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="buscar_solicitante_pelo_executante()"
                                :disabled="$store.state.loading" v-if="!value.fl_indicador">
                                <i class="fas fa-equals fa-fw mr-2"></i>
                                Executante
                            </button>
                        </div>
                        <div class="input-group-append" v-if="value.medico_solicitante && value.medico_solicitante.id_medico_solicitante">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                @click="value.medico_solicitante.edicao = !value.medico_solicitante.edicao"
                                :disabled="$store.state.loading">
                                <i class="fas fa-pen fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>

            </div>

            <template v-if="value.medico_solicitante">

                <div class="col col-12 col-md-2">
                    <az-input
                        :label="( can_remove && !value.fl_indicador ) ? '' : 'Número do Conselho'"
                        sizing="sm"
                        type="text"
                        v-model="value.medico_solicitante.st_numero_conselho"
                        :edicao="edicao_solic && !value.medico_solicitante.id_medico_solicitante && !!value.medico_solicitante.st_nome"
                        :validate="validate" />
                </div>

                <div class="col col-12 col-md-2">
                    <az-input 
                        :label="( can_remove && !value.fl_indicador ) ? '' : 'Conselho'"
                        sizing="sm"
                        type="select"
                        optionsMode="aql"
                        service="conselhos.index"
                        optionsData="id_conselho"
                        optionsDisplay="st_sigla"
                        v-model="value.medico_solicitante.id_conselho"
                        :edicao="edicao_solic && !value.medico_solicitante.id_medico_solicitante && !!value.medico_solicitante.st_nome"
                        :required="required"
                        :validate="validate" />
                </div>

                <div class="col col-12 col-md-2">
                    <az-input 
                        :label="( can_remove && !value.fl_indicador ) ? '' : 'UF'"
                        sizing="sm"
                        type="select"
                        optionsMode="aql"
                        service="estados.index"
                        optionsData="id_estado"
                        optionsDisplay="st_estado"
                        v-model="value.medico_solicitante.id_estado_conselho"
                        :edicao="edicao_solic && !value.medico_solicitante.id_medico_solicitante && !!value.medico_solicitante.st_nome"
                        :required="required"
                        :validate="validate" />
                </div>

            </template>

        </div>

        <div class="form-row" v-if="value.medico_solicitante">

            <div class="col col-12" :class="block_data ? 'col-md-6' : 'col-md-4'">
                <az-input
                    sizing="sm"
                    type="autocomplete"
                    optionsMode="aql"
                    service="especialidades.index"
                    optionsDisplay="search"
                    :optionsSync="false"
                    v-model="value.medico_solicitante.especialidade"
                    edicao2="edicao_solic"
                    :validate="validate">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend">
                            <span class="input-group-text" title="Especialidade">
                                CBO
                            </span>
                        </div>
                    </template>
                </az-input>

            </div>

            <div class="col col-12 col-md-2" v-if="!block_data">
                <az-input
                    title="Data da Solicitação"
                    sizing="sm"
                    type="date"
                    v-model="value.dt_solicitacao"
                    :edicao="edicao && !alter_proc"
                    :required="required"
                    :validate="validate">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="pode_info_contratado">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="toggle_info_contradado()" title="Informar Contratado Solicitante">
                                <i class="fa-solid fa-hospital-user fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>

            <div class="col col-12 col-md-6">
                <az-input
                    v-if="!refresh_cid && !alter_proc"
                    sizing="sm"
                    type="autocomplete"
                    optionsMode="aql"
                    service="cids.index"
                    optionsData="id_cid"
                    optionsDisplay="search"
                    v-model="value.id_cid"
                    :edicao="edicao"
                    :validate="validate"
                    :required="!value.id_cid && exige_cid ()">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend">
                            <span class="input-group-text" title="CID">
                                CID
                            </span>
                        </div>
                    </template>

                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="eh_atendimento()">
                            <button class="btn" :class="cidInfoShow ? 'btn-primary' : 'btn-outline-primary'" type="button" id="button-addon2" @click="cidDetail()">
                                <i class="fas fa-info-circle" aria-hidden="true"></i>    
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>

        </div>

        <div class="form-row" v-if="pode_info_contratado && value && value.js_info && value.js_info.info_contratado">
            <div class="col col-12 col-md-6">
                <az-input
                    sizing="sm"
                    type="text"
                    :compact="true"
                    v-model="value.js_info.contratado"
                    :edicao="edicao"
                    :validate="validate"
                    label="Contratado Solicitante">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="pesquisar_contratado()">
                                <i class="fas fa-search fa-fw"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>

            <div class="col col-12 col-md-6">
                <az-input
                    sizing="sm"
                    type="text"
                    :compact="true"
                    v-model="value.js_info.codigo_contratado"
                    :edicao="edicao"
                    :validate="validate"
                    label="Código" />
            </div>
        </div>

        <div class="form-row" v-if="cidInfoShow">
            <div v-if="1 == 0" class="col col-12 col-md-3">
                <az-input
                    type="select"
                    sizing="sm"
                    optionsMode="json"
                    :optionsList="[{ id: 'A', search: 'Aguda' }, { id: 'C', search: 'Crônica' }]"
                    optionsData="id"
                    optionsDisplay="search"
                    label="Tipo de Doença" />
            </div>
            <div v-if="1 == 0" class="col col-12 col-md-3">
                <div ref="azinput" class="form-group" :class="mb ? 'mb-1' : 'mb-0'">
                    <small class="form-text text-muted text-nowrap text-truncate">
                        Tempo da Doença
                    </small>
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control" value="Tempo..." />
                        <span class="input-group-btn"></span>
                        <select class="form-control">
                            <option value="D">Dia(s)</option>
                            <option value="D">Mes(es)</option>
                            <option value="D">Ano(s)</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col col-12 col-md-6">
                <az-input
                    type="select"
                    sizing="sm"
                    optionsMode="json"
                    :optionsList="[
                            { id: '0', search: 'Acidente de trabalho ou doença relacionada ao trabalho' },
                            { id: '1', search: 'Acidente de trânsito' },
                            { id: '2', search: 'Outros acientes' },
                            { id: '9', search: 'Nenhum' }]"
                    optionsData="id"
                    optionsDisplay="search"
                    placeholder="Selecione a indicação de acidente"
                    v-model="value.in_relacao_acidente_doenca"
                    label="Indicação de Acidente" />
            </div>
        </div>

        <pre v-if="false" class="alert alert-warning">{{ value }}</pre>

        <!-- Modal da Empresa -->
        <template v-if="pode_info_contratado && exibir_modal_contrado">
            <div class="modal fade" id="modalContratado" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Contratado Solicitante</h5>
                            <button type="button" class="close" @click="fechar_modal('modalContratado')" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <az-input
                                sizing="sm"
                                label="Pesquisar"
                                v-model="pesq_contratado"
                                type="autocomplete"
                                optionsMode="aql"
                                service="centro_cirurgicos.index"
                                optionsDisplay="st_centro_cirurgico"
                                :optionsParm="{ ativos: true }"
                                :validate="validate" />

                            <br><br><br><br><br><br><br><br><br><br>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="fechar_modal('modalContratado')">Cancelar</button>
                            <button type="button" class="btn btn-success" v-if="pesq_contratado" @click="selecionar_contratado()">Selecionar</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import $ from 'jquery'; 
import AzInput from './forms/AzInput.vue';

export default {
    data () {
        return {
            dados: null,
            cidInfoShow: false,
            refresh_cid: false,
            pesq_contratado: "", 
            exibir_modal_contrado: false, 
        }
    },

    components: {
        AzInput,
    },

    computed: {
        edicao_solic: function () {
            return this.edicao && ( this.value.medico_solicitante ? this.value.medico_solicitante.edicao : false );
        }
    },

    props: ['validate', 'value', 'required', 'edicao', 'mb', 'alter_proc', 'block_executante', 'can_remove', 'block_form', 'block_data', 'block_incluir', 'pode_info_contratado'],

    methods: {
        selecionar_contratado () { 
            this.value.js_info.contratado = this.pesq_contratado.st_centro_cirurgico;
            this.value.js_info.codigo_contratado = this.pesq_contratado.st_codigo_operadora 
                ? this.pesq_contratado.st_codigo_operadora 
                : this.pesq_contratado.st_cnpj;

            this.fechar_modal('modalContratado');
        },

        pesquisar_contratado () { 
            this.pesq_contratado = ""; 
            this.exibir_modal_contrado = true; 

            this.$nextTick(() => {
                $('#modalContratado').modal('show');
            });
        },

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },

        toggle_info_contradado () { 
            if ( !this.value.js_info ) { 
                this.value.js_info = { info_contratado: true, contratado: "", codigo_contratado: "" };
            } else if ( this.value.js_info && this.value.js_info.info_contratado ) {
                this.value.js_info.info_contratado = false;
            } else if ( this.value.js_info && !this.value.js_info.info_contratado ) {
                this.value.js_info.info_contratado = true;
            }

            this.$forceUpdate(); 
        },

        tratarMedico () {
            if ( this.value.medico_solicitante && typeof this.value.medico_solicitante == 'string' ) {
                this.value.medico_solicitante = {
                    id_medico_solicitante: null,
                    st_nome: this.value.medico_solicitante.toUpperCase(),
                    search: this.value.medico_solicitante.toUpperCase(),
                    edicao: true,
                    st_numero_conselho: "",
                    id_conselho: "",
                    id_estado_conselho: "",
                    especialidade: "",
                }
            }
        },

        eh_atendimento () {
            return this.value.atendimento_procedimentos ? true : false;
        },

        exige_cid () {
            if ( !this.value.atendimento_procedimentos )
                return false;

            return this.value.atendimento_procedimentos.find (item => {
                return item.procedimento && item.procedimento.restricao && item.procedimento.restricao.length &&
                    !item.procedimento.restricao[0].fl_nao_possui_cobertura &&
                    item.procedimento.restricao[0].fl_cid_atendimento;
            }) ? true : false;
        },

        definir_cid(id_cid) {
            this.refresh_cid = true;
            this.value.id_cid = id_cid;

            this.$nextTick(() => {
                this.refresh_cid = false;
            });
        },

        cidDetail() {
            this.cidInfoShow = !this.cidInfoShow;
        },

        setNomeMedico (value) {
            if ( this.value.medico_solicitante && !this.value.medico_solicitante.id_medico_solicitante )
                this.value.medico_solicitante.st_nome = value;
        },

        buscar_solicitante_pelo_executante(executante = null) {

            if ( !executante )
                executante = this.value.medico;

            this.$store.commit('loading', true);

            //console.log('V', this.value);

            this.$util.loadItem(this, {
                service: "medicos",
                func: "show",
                parms: {
                    id: executante.id_pessoa,
                    com_solicitante: true,
                }
            })
            .then(res => {
                if ( res.solicitante ) {
                    this.value.medico_solicitante = res.solicitante;
                } else {
                    this.value.medico_solicitante = {
                        st_nome: res.pessoa.st_nome,
                        st_numero_conselho: res.in_numero_conselho,
                        id_conselho: res.id_conselho,
                        id_estado_conselho: res.id_estado_conselho,
                        especialidade: this.dados ? this.dados.procedimento.especialidade : null,
                        search: res.pessoa.st_nome,
                    };
                }

                if ( !this.value.dt_solicitacao ) {
                    this.value.dt_solicitacao = this.$util.hoje().substr(0,10);
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },
    }
}
</script>
